import Vue from 'vue'
import Vuex from 'vuex'
/* import dispatchActionForAllModules from '@utils/dispatch-action-for-all-modules' */

import modules from './modules'
import oidcStore from './createModuleStore/oidcStore'
import StoreProvider from './boot'
import { PersistedStorages } from './plugins/createPersistedState'

Vue.use(Vuex)

async function intializeStore() {
  const storageKey = '123'

  console.log('oidcstore', oidcStore)
  await StoreProvider.initialize({
    modules: {
      ...modules,
      ...oidcStore,
    },
    persistedOptions: {
      storage: PersistedStorages(storageKey).localForage,
      key: storageKey,
      paths: ['frontDeskInstructions', 'i18n', 'announcements'],
      expirationTime: 60,
      isAsyncStorage: true,
    },
  })

  return StoreProvider.getStore()
}

export default intializeStore
